import "../style/dashboard/ExamStore.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import calendar_icon from "../../assets/dashboard/exam-list/stickynote.svg";
import { BsClock } from "react-icons/bs";
import solo_icon from "../../assets/dashboard/exam-list/vuesax-linear-profile.svg";
import group_icon from "../../assets/dashboard/exam-list/vuesax-linear-profile-2user.svg";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "jalali-moment";

// let my_exam_list_data = [
//   {
//     id: 1,
//     tab_name: "همه",
//     isActive: true,
//     tab_content: [
//       {
//         id: 1,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
//       },
//       {
//         id: 2,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,70,26,1) 0%, rgba(114,255,180,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,70,26,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
//       },
//       {
//         id: 3,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(206,206,28,1) 0%, rgba(255,255,114,0) 100%)",
//         },
//         type: "group",
//         under_cover_style: {
//           backgroundColor: "rgba(206,206,28,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
//       },
//       {
//         id: 4,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//       {
//         id: 5,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//       {
//         id: 6,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//       {
//         id: 7,
//         sub_id: 1,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 28 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//     ],
//   },
//   {
//     id: 2,
//     tab_name: "آزمون‌های‌جاری",
//     isActive: false,
//     tab_content: [
//       {
//         id: 1,
//         sub_id: 2,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 20 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//     ],
//   },
//   {
//     id: 3,
//     tab_name: "آزمون‌های‌آینده",
//     isActive: false,
//     tab_content: [
//       {
//         id: 1,
//         sub_id: 3,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 20 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//     ],
//   },
//   {
//     id: 4,
//     tab_name: "آزمون‌های‌درحال‌بارگزاری",
//     isActive: false,
//     tab_content: [
//       {
//         id: 1,
//         sub_id: 4,
//         img: img1,
//         azmoon: "آزمون تاریخ شفاهی ایران",
//         date: "سه شنبه 20 آبان 1400 ",
//         time: "21:30",
//         cover_style: {
//           background:
//             "linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 100%)",
//         },
//         type: "solo",
//         under_cover_style: {
//           backgroundColor: "rgba(0,31,70,0.3)",
//         },
//         description:
//           "توضیحات آزمون: لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنو کاربردی می باشد.",
//       },
//     ],
//   },
// ];

const ExamStore = () => {
  const state = useSelector((state) => state.default);
  //create suitable data list with main data----------------------------------------------------
  let d = new Date();
  console.log("today:"+d);
  let d_day = d.getDay();
  console.log("today_day:"+d_day);
  let LastDayWeekDate=d;
  switch (d_day) {
    case 1:
      LastDayWeekDate.setDate(d.getDate() + 4);
      break;
    case 2:
      LastDayWeekDate.setDate(d.getDate() + 3);
      break;
    case 3:
      LastDayWeekDate.setDate(d.getDate() + 2);
      break;
    case 4:
      LastDayWeekDate.setDate(d.getDate() + 1);
      break;
    case 6:
      LastDayWeekDate.setDate(d.getDate() + 6);
      break;
    case 7:
      LastDayWeekDate.setDate(d.getDate() + 5);
      break;
    default:
      LastDayWeekDate=d
      break;
  }
  let my_exam_list_data2 = [
    {
      id: 1,
      tab_name: "همه",
      isActive: true,
      tab_content: []
    },
    {
      id: 2,
      tab_name: "آزمون‌های این هفته",
      isActive: false,
      tab_content: []
    },
    {
      id: 3,
      tab_name: "آزمون‌های آینده",
      isActive: false,
      tab_content: []
    },
    {
      id: 4,
      tab_name: "آزمون‌های در حال برگزاری",
      isActive: false,
      tab_content: []
    },
  ]
  for(let b=0;b<state.ExamData.length;b++){
    if(b<8){
      let date = new Date(state.ExamData[b].date);
      let TabType = 1;
      console.log(date);
      let endDate = new Date(state.ExamData[b].endDate);
      if(date<LastDayWeekDate){
        TabType = 1;
        my_exam_list_data2[1].tab_content.push({...state.ExamData[b],tabType:1,sub_id:2});
      }
      else if(date>LastDayWeekDate){
        TabType = 2;
        my_exam_list_data2[2].tab_content.push({...state.ExamData[b],tabType:2,sub_id:3});
      }
      let D = new Date();
      if(D>date && D<endDate){
        TabType = 3;
        my_exam_list_data2[3].tab_content.push({...state.ExamData[b],tabType:3,sub_id:4});
      }
      my_exam_list_data2[0].tab_content.push({...state.ExamData[b],sub_id:1,tabType:TabType});
    }   
  }
  console.log(my_exam_list_data2);
  const [data, set_data] = useState(my_exam_list_data2);
  //------------------------------------------------------

  //cover style list  ------------------------------------
  let coverStyleList=[
    {
      background:"linear-gradient(0deg, rgba(0,31,70,1) 0%, rgba(114,177,255,0) 60%)",
    },
    {
      background:"linear-gradient(0deg, rgba(0,70,26,1) 0%, rgba(114,255,180,0) 60%)",
    },
    {
      background:"linear-gradient(0deg, rgba(206,206,28,1) 0%, rgba(255,255,114,0) 60%)",
    },
  ]
  let underCoverStyleList=[
    {
      background:"#72B1FF",
      opacity:0.5
    },
    {
      background:"#72FFB4",
      opacity:0.5
    },
    {
      background:"#FFFF72",
      opacity:0.5
    },
  ]
  //-----------------------------------------------------------
  const [old_tab_id, set_old_tab_id] = useState(1);
  let i = 0;
  let max_i;
  for (let j = 0; j < data.length; j++) {
    // console.log(data[j].isActive);
    if (data[j].isActive) {
      max_i = (data[j].tab_content.length - 3) * -1;
      // console.log(max_i);
    }
  }


  if (state.openNav === "open") {
    max_i--;
    if (window.innerWidth < 1360) {
      let tab_name_item = document.querySelectorAll(".eslc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "15px";
      }
    }
    if (window.innerWidth < 1305) {
      let tab_name_item = document.querySelectorAll(".eslc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "13px";
      }
    }
    if (window.innerWidth < 1212) {
      let tab_name_item = document.querySelectorAll(".eslc-h-tab-name-item");
      for (let p = 0; p < tab_name_item.length; p++) {
        tab_name_item[p].style.fontSize = "11px";
      }
    }
  }
  if (window.innerWidth < 1536) {
    max_i--;
  }
  if (window.innerWidth < 1170) {
    max_i--;
  }

  const move_left = () => {
    // console.log(i);
    if (i > max_i) {
      i--;
      let movment = i * 245;
      document.querySelector(".eslc-content-item").style.right = `${movment}px`;
    }
  };

  const move_right = () => {
    if (i < 0) {
      i++;
      let movment = i * 245;
      document.querySelector(".eslc-content-item").style.right = `${movment}px`;
    }
  };

  const change_tab = (id) => {
    let new_data = data.map((item) => {
      if (item.id === old_tab_id) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
      }
      return { ...item };
    });
    // console.log(new_data);
    set_data(new_data);
    set_old_tab_id(id);
    // console.log(old_tab_id);
  };

  let s = 0;
  const item_active_hover = (id, sub_id) => {
    // console.log(id, sub_id);
    // s = 0;
    let ss = 0;
    for (let k = 0; k < data.length; k++) {
      s = 0;
      for (let v = 0; v < data[k].tab_content.length; v++) {
        // console.log(data[k].tab_content[v]);
        s++;
        if (
          data[k].tab_content[v].id === id &&
          data[k].tab_content[v].sub_id === sub_id
        ) {
          ss = 1;
          break;
        }
      }
      if (ss) {
        break;
      }
    }
    // console.log(s);
    document.querySelectorAll(".eslc-c-i-i-under-cover")[
      s - 1
    ].style.transform = "scaleY(1)";
    document
      .querySelectorAll(".eslc-c-i-i-info-descriptin")
      [s - 1].classList.add("es_descript_is_active");
  };

  const item_deactive_hover = (id, sub_id) => {
    if (s > 0) {
      document.querySelectorAll(".eslc-c-i-i-under-cover")[
        s - 1
      ].style.transform = "scaleY(0)";
      document
        .querySelectorAll(".eslc-c-i-i-info-descriptin")
        [s - 1].classList.remove("es_descript_is_active");
    }
    // if(e.target.previousElementSibling !=null){
    //   e.target.previousElementSibling.style.transform="scaleY(0)";
    // }
  };
  moment.locale("en");

  return (
    <div className="exam-store">
      <div className="exam-store-list-title">فروشگاه آزمون‌ها</div>
      <div className="exam-store-list-content">
        <div className="eslc-header">
          {data.map((item, i) => (
            <div
              style={item.isActive ? { color: "#2E81E8" } : null}
              key={item.id || i}
              className="eslc-h-tab-name-item"
              onClick={() => change_tab(item.id)}
            >
              {item.tab_name}
              {item.isActive && (
                <div className="eslc-h-tab-name-item-line"></div>
              )}
            </div>
          ))}
          <div className="eslc-h-move-btns">
            <IoIosArrowBack onClick={move_left} />
            <IoIosArrowForward onClick={move_right} />
          </div>
        </div>
        <div className="eslc-content">
          {data.map((item, i) => (
            <div key={item.id || i}>
              {item.isActive && (
                <div key={item.id} className="eslc-content-item">
                  {item.isActive &&
                    item.tab_content.map((item, j) => (
                      <div
                        key={item.id || j}
                        className="eslc-content-i-item"
                        onMouseEnter={() =>
                          item_active_hover(item.id, item.sub_id)
                        }
                        onMouseLeave={() =>
                          item_deactive_hover(item.id, item.sub_id)
                        }
                      >
                        <img
                          className="eslc-c-i-i-bg"
                          src={item.img}
                          alt="azmoon-img"
                        />
                        <div
                          style={underCoverStyleList[item.tabType-1]}
                          className="eslc-c-i-i-under-cover"
                        ></div>
                        <div
                          style={coverStyleList[item.tabType-1]}
                          className="eslc-c-i-i-cover"
                        ></div>
                        <div className="eslc-c-i-item-info">
                          <div className="eslc-c-i-i-info-title">
                            <img src={calendar_icon} alt="calendar-icon" />
                            {item.name}
                          </div>
                          <div className="eslc-c-i-i-info-line"></div>
                          <div className="eslc-c-i-i-info-date-time">
                            <div className="eslc-ciiidt-date-container">
                              <BsClock className="eslc-clock-icon" />
                              <div className="eslc-ciiidt-date">
                                {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
                              </div>
                            </div>
                            <div className="eslc-ciiidt-time">
                              ساعت {item.time}
                            </div>
                          </div>
                          <div className="eslc-c-i-i-info-line"></div>
                          <div className="eslc-c-i-item-info-type">
                            {item.type === 1 && (
                              <img src={solo_icon} alt="" />
                            )}
                            {item.type === 1 && (
                              <div className="eslc-c-i-item-info-type-text">
                                آزمون تک نفره
                              </div>
                            )}
                            {item.type === 2 && (
                              <img src={group_icon} alt="" />
                            )}
                            {item.type === 2 && (
                              <div className="eslc-c-i-item-info-type-text">
                                آزمون چند نفره
                              </div>
                            )}
                          </div>
                          <div className="eslc-c-i-i-info-descriptin">
                            {item.descripton}
                          </div>
                        </div>
                      </div>
                    ))}
                  <Link
                    to="/dashboard/store"
                    className="eslc-content-item-more"
                  >
                    مشاهده بیشتر
                  </Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamStore;
